import React, { useState } from "react";
import "./styles.css";
import FloatingActions, { FloatingAction } from "../FloatingActions";
import { AgGridReact } from "ag-grid-react";
import { themeQuartz } from "ag-grid-community";
import { AG_GRID_LOCALE_CZ } from '@ag-grid-community/locale';
import useItemListCardLogic from "./useItemListLogicOdmraz";
import { FetchItemsFn, Item, ListScope, UiColumn } from "./types";
import DeicingSummaryFilterDialogWindow from "../DeicingSummaryFilterDialogWindow";
import DeicingEcoFilterDialogWindow from "../DeicingEcoFilterDialogWindow";

const myTheme = themeQuartz.withParams({
  fontSize: 17,
  headerFontSize: 17,
  rowHeight: 55,
  headerHeight: 48,
});

export interface ItemListOdmrazProps {
  columns: UiColumn<Item>[];
  actions?: FloatingAction[];
  fetchItems: FetchItemsFn<Item>;
  rowSelectionMode?: boolean;
  onChangedScope: (scope: ListScope) => void;
  scope: string;
  expanded?: Set<string>;
  toggleNode?: (id: string) => void;
}

const ItemListOdmraz: React.FC<ItemListOdmrazProps> = ({ columns, fetchItems, rowSelectionMode, onChangedScope, scope, expanded, toggleNode }) => {

  const logic = useItemListCardLogic({ columns, fetchItems, rowSelectionMode, onChangedScope, scope, expanded, toggleNode });
  const [openDeiceSummaryWindow, setOpenDeiceSummaryWindow] = useState<boolean>(false);
  const [openDeiceEcoWindow, setOpenDeiceEcoWindow] = useState<boolean>(false);

  return <>
    {openDeiceSummaryWindow &&
      <DeicingSummaryFilterDialogWindow
        onCloseDialog={() => setOpenDeiceSummaryWindow(false)}
        onConfirmDialog={(data) => { logic?.onPrintSummaryItems(data); setOpenDeiceSummaryWindow(false); }}
      >
      </DeicingSummaryFilterDialogWindow>}
      {openDeiceEcoWindow &&
      <DeicingEcoFilterDialogWindow
        onCloseDialog={() => setOpenDeiceEcoWindow(false)}
        onConfirmDialog={(data) => { logic?.onPrintEcoProtocol(data); setOpenDeiceEcoWindow(false); }}
      >
      </DeicingEcoFilterDialogWindow>}
    <div className="item-list-card main-stock-list">

      <div className="item-list-toolbar">

        <button
          type="button"
          className={`item-list-tab ${scope === "all" ? "is-active" : ""}`}
          onClick={() => { onChangedScope("all"); }}
        >
          Seznam kapalin
        </button>
        <button
          type="button"
          className={`item-list-tab ${scope === "allItems" ? "is-active" : ""}`}
          onClick={() => { onChangedScope("allItems"); }}
        >
          Odmrazy - Přehled
        </button>
        <button type="button" className="item-list-tab" onClick={() => onChangedScope("deicingDashboard")}>
          Statistika
        </button>
        {/* <button
          type="button"
          className={`item-list-tab ${scope === "allItemsGrouped" ? "is-active" : ""}`}
          onClick={() => { onChangedScope("allItemsGrouped"); }}
        >
          Odmrazy - Přehled (Seskupeno)
        </button> */}

        <div className="item-list-toolbar-right">
          {scope === "allItems" && <button
            type="button"
            className={`item-list-tab is-active`}
            onClick={() => logic?.onPrintProtocol()}
          >
            Protokol (PDF)
          </button>}
          {scope === "allItems" && <button
            type="button"
            className={`item-list-tab is-active`}
            onClick={() => setOpenDeiceSummaryWindow(true)}
          >
            Přehled (Excel)
          </button>}
           {scope === "allItems" && <button
            type="button"
            className={`item-list-tab is-active`}
            onClick={() => setOpenDeiceEcoWindow(true)}
          >
            Ekologie (Excel)
          </button>}
          <select
            value={logic.selectedStockState}
            onChange={logic.onChangeSelectedStock}
          >
            {logic.stocksState.map((o) => (
              <option key={o.id} value={o.id}>
                {o.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="item-list-grid-wrapper">
        <AgGridReact
          theme={myTheme}
          columnDefs={logic.columnDefs}
          // rowModelType="infinite"
          // cacheBlockSize={100}
          rowData={logic.rowData}
          // datasource={logic.datasource}
          localeText={AG_GRID_LOCALE_CZ}
          // suppressRowClickSelection={true}
          getRowId={
            scope === "all" || scope === "allItems"
              ? undefined
              : (params) => params.data.treeId
          }

          rowSelection={rowSelectionMode ? logic.rowSelection : undefined}
          onGridReady={(e) => { logic.gridApiRef.current = e.api; }}
          suppressCellFocus={true}
          suppressMovableColumns={true}
          onRowClicked={/*scope === "allItems" ||*/ scope === "allItemsGrouped" ? logic?.onRowClicked : undefined}
        //  groupDisplayType="multipleColumns"
        // onCellValueChanged={scope === "allItems" && logic.loggedUser?.userrole === "admin" ? logic.handleCellValueChanged : null}
        />
      </div>

      {scope === "all" && <div className="stockGrid__footer">
        {logic.countsByState?.length > 0 && (
          <span className="stockGrid__footerSep">
            Stav:
            <span className="stockGrid__chips">
              {logic.countsByState.map((x) => (
                <span key={x.key} className="stockGrid__chip">
                  {x.key}: <b>{x.count}</b>
                </span>
              ))}
            </span>
            <span className="stockGrid__footerDivider">|</span>
          </span>
        )}

        <span className="stockGrid__total">
          Celkem: <b>{logic.totalCount}</b>
        </span>
      </div>}

      {
        logic.actions?.length ? (
          <div className="item-list-actions">
            <FloatingActions actions={logic.actions} />
          </div>
        ) : null
      }
    </div >
  </>;
};

export default ItemListOdmraz;
